export const rearrangeKeys = (keys: string[]): string[] => {
  const monthOrder = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const getDateValue = (key: string): number | null => {
    const match = key.match(/Installment (\w+)-(\d{2})/);
    if (!match) return null;

    const [, month, year] = match;
    const numericYear = 2000 + Number(year);
    const monthIndex = monthOrder.indexOf(month);

    return numericYear * 12 + monthIndex;
  };

  const normalKeys = keys.filter(
    (key) => !key.startsWith('Installment') && key !== 'Total'
  );

  const installmentKeys = keys
    .filter((key) => key.startsWith('Installment'))
    .sort((a, b) => {
      const aValue = getDateValue(a);
      const bValue = getDateValue(b);
      return (aValue ?? 0) - (bValue ?? 0);
    });

  const totalKey = keys.includes('Total') ? ['Total'] : [];

  return [...normalKeys, ...installmentKeys, ...totalKey];
};
